import { render, staticRenderFns } from "./MenuLinkMobile.vue?vue&type=template&id=9d057612&scoped=true&"
import script from "./MenuLinkMobile.vue?vue&type=script&lang=js&"
export * from "./MenuLinkMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d057612",
  null
  
)

export default component.exports